"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DownloadButton = void 0;
var DownloadFile = _interopRequireWildcard(require("@ori-events/download-file"));
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _analyticsData = require("@ori/analytics-data");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _useDownloadButtonData = require("./useDownloadButtonData");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const DownloadButton = exports.DownloadButton = /*#__PURE__*/ (0, _react.memo)(()=>{
    const { translations } = (0, _useTranslations.useTranslations)();
    const { getTestId } = (0, _testidGenerator.default)();
    const { catalogueId, downloadLink } = (0, _useDownloadButtonData.useDownloadButtonData)();
    const dispatchDownloadFileEvent = (0, _react.useCallback)(()=>{
        window.dispatchEvent(new CustomEvent(DownloadFile.Name, {
            detail: {
                id: catalogueId,
                name: "".concat(catalogueId, ".pdf"),
                pageUrl: window.location.href,
                placement: _analyticsData.Placement.DigitalCatalogueECatalogue,
                target: downloadLink
            }
        }));
    }, [
        catalogueId,
        downloadLink
    ]);
    if (!downloadLink) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.IconButton, {
        "aria-label": translations.download,
        "data-testid": getTestId(_constants.DOWNLOAD_BUTTON),
        href: downloadLink,
        title: translations.download,
        variant: "contained",
        color: "default",
        size: "large",
        onClick: dispatchDownloadFileEvent,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Download, {
            fontSize: "inherit"
        })
    });
});
